(() => {
  const script = document.currentScript;
  if (!script || window.lsButtonLift) return;
  window.lsButtonLift = true;

  const targets = script.dataset.targets;
  const QUERY = '(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)';
  const BLOCKED = ':disabled, [aria-disabled="true"], [aria-busy="true"]';
  /* Shared GSAP loader for every page script, defined before the hover-only exit so touch devices get it too */
  let loading = null;
  window.lsLoadGsap = window.lsLoadGsap || ((src) => {
    if (window.gsap) return Promise.resolve(window.gsap);
    if (!loading) {
      loading = new Promise((resolve, reject) => {
        const done = () => (window.gsap ? resolve(window.gsap) : reject());
        const existing = document.querySelector('script[src*="/gsap.min.js"]');
        if (existing) {
          existing.addEventListener('load', done, { once: true });
          existing.addEventListener('error', reject, { once: true });
          return;
        }
        const tag = document.createElement('script');
        tag.src = src;
        tag.async = true;
        tag.onload = done;
        tag.onerror = reject;
        document.head.appendChild(tag);
      });
    }
    return loading;
  });

  if (!targets || !window.matchMedia(QUERY).matches) return;

  let started = false;
  const start = () => {
    if (started) return;
    started = true;
    run();
  };
  const run = () => window.lsLoadGsap(script.dataset.gsapSrc).then((gsap) => {
    const root = document.documentElement;
    const find = (e) => {
      const el = e.target instanceof Element ? e.target.closest(targets) : null;
      if (!el || (e.relatedTarget instanceof Node && el.contains(e.relatedTarget))) return null;
      return el;
    };

    const lift = (e) => {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      const el = find(e);
      if (!el || el.matches(BLOCKED)) return;
      if (!el.style.getPropertyValue('--ls-lift')) el.style.setProperty('--ls-lift', '0');
      el.classList.add('ls-lifted');
      gsap.to(el, { '--ls-lift': 1, duration: 0.28, ease: 'power3.out', overwrite: true });
    };

    const settle = (e) => {
      const el = find(e);
      if (!el || !el.classList.contains('ls-lifted')) return;
      gsap.to(el, {
        '--ls-lift': 0,
        duration: 0.22,
        ease: 'power2.out',
        overwrite: true,
        onComplete: () => {
          el.classList.remove('ls-lifted');
          el.style.removeProperty('--ls-lift');
        },
      });
    };

    gsap.matchMedia().add(QUERY, () => {
      root.classList.add('ls-lift-js');
      document.addEventListener('pointerover', lift);
      document.addEventListener('pointerout', settle);
      return () => {
        root.classList.remove('ls-lift-js');
        document.removeEventListener('pointerover', lift);
        document.removeEventListener('pointerout', settle);
        document.querySelectorAll('.ls-lifted').forEach((el) => {
          el.classList.remove('ls-lifted');
          el.style.removeProperty('--ls-lift');
        });
      };
    });
  }).catch(() => {});

  const onFirst = (e) => {
    if (!(e.target instanceof Element) || !e.target.closest(targets)) return;
    document.removeEventListener('pointerover', onFirst);
    start();
  };
  document.addEventListener('pointerover', onFirst);
  if ('requestIdleCallback' in window) window.requestIdleCallback(() => start(), { timeout: 4000 });
  else window.setTimeout(start, 2500);
})();
